<!-- apps/frontend/src/components/flow/nodes/EndCallNode.vue -->
<template>
  <div :class="['group bg-gray-700 border-2 rounded-lg shadow-lg w-64 relative overflow-visible',
                selected ? 'border-orange-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']">
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-orange-400" aria-hidden="true">call_end</span>
        <strong class="text-white text-sm">{{ $t('flowEditor.palette.endCall') }}</strong>
      </div>
      <ExitNodeBadge :active="data.__isExitNode" />
      <ValidationMarker :error="data.__validationError" />
    </div>
    <div class="p-3">
      <p class="text-gray-400 text-xs truncate">
        <span v-if="data.message" class="text-orange-300" v-tooltip="data.message">{{ data.message }}</span>
        <span v-else>{{ $t('flowEditor.endCallEditor.noMessageSet') }}</span>
      </p>
    </div>
    <Handle type="target" :position="Position.Left" />
    <Handle type="source" :position="Position.Right" />
    <AddNodeButton v-if="!hasOutgoingEdge" accent="orange" @add="emit('add-node', nodeId)" />
  </div>
</template>
<script setup>
import { Handle, Position } from '@vue-flow/core';
import ExitNodeBadge from './ExitNodeBadge.vue';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';
const emit = defineEmits(['add-node']);
defineProps({
  data:            { type: Object,  required: true },
  selected:        { type: Boolean, default: false },
  nodeId:          { type: String,  required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});
</script>
